import { useMyCareTeamRoles } from './useMyCareTeamRoles'

export const SHARED_CHAT_ROLE = 'therapist'

// The therapist's chat is the shared thread, so only a provider holding that role (or none) reads it here.
export const useHideSharedChat = (): boolean => {
  const roles = useMyCareTeamRoles()
  return roles === undefined || (roles.length > 0 && !roles.includes(SHARED_CHAT_ROLE))
}
